import axios from 'axios';
import { CustomToast } from 'components';
import { logoutUser } from 'utils/extra';
import _get from 'lodash/get';

function setup() {
  axios.defaults.timeout = 30000; // 30 seconds

  axios.interceptors.response.use(
    responseSuccessInterceptor,
    responseErrorInterceptor
  );
}

function responseSuccessInterceptor(response) {
  const res = _get(response, 'data');
  const url = _get(response, 'config.url');
  res.statusCode = _get(response, 'status');
  res.notified = notify(res);
  if (!res.data || res.data === null) {
    const error = new Error(`Api Error: - ${url}`);
    error.displayMessage = 'Error fetching data. Please try again later';
    error.responseReceived = res;
    return Promise.reject(error);
  }
  return res;
}

function responseErrorInterceptor(error) {
  const url = _get(error, 'config.url');
  const method = (_get(error, 'config.method') || '').toUpperCase();
  const headers = _get(error, 'config.headers') || {};
  const status =
    _get(error, 'response.status') !== null
      ? _get(error, 'response.status')
      : -1;
  error.message = `${method} ${status} ${url}`;

  if (
    (status === 401 || status === 403) &&
    headers['Authorization'] &&
    headers['Authorization'].length > 0
  ) {
    logoutUser(); // force user logout if 401 received for that token
    return error;
  }

  const res = _get(error, 'response.data');
  error.method = _get(error, 'config.method');
  error.statusCode = status;
  error.url = url;
  error.notified = notify(res);
  if (!error.notified) {
    error.displayMessage = _get(res, 'displayMessage');
  }
  return Promise.reject(error);
}

function notify(res) {
  const show = _get(res, 'displayMessage.showToUser', false);
  if (show) {
    const { message, level } = _get(res, 'displayMessage', {});
    CustomToast({ msg: message, type: level });
    res.notified = true;
  }
  return show;
}

export default setup;
